import { FavoriteClient, Favorite, FavoriteId } from 'api/clients/FavoriteClient'
import { addFavorite, deleteFavorite, favoritesSet } from 'redux/actions'
import { Dispatch } from 'redux'

export const FavoriteService = {
  createFavorite: async <T extends Favorite>(
    id: T['favoritable_id'],
    type: T['favoritable_type'],
    dispatch: Dispatch,
  ) => {
    const response = await FavoriteClient.createFavorite(id, type)

    if (response.type === 'success') {
      dispatch(addFavorite(response.data.favorite))
    }

    return response
  },
  deleteFavorite: async (id: FavoriteId, dispatch: Dispatch) => {
    const response = await FavoriteClient.deleteFavorite(id)

    if (response.type === 'success') {
      dispatch(deleteFavorite(id))
    }

    return response
  },
  getFavorites: async (dispatch: Dispatch) => {
    const response = await FavoriteClient.getFavorites()

    if (response.type === 'success') {
      dispatch(favoritesSet(response.data.favorites))
    }

    return response
  },
  insertAt: async (id: FavoriteId, position: Favorite['position'], dispatch: Dispatch) => {
    const response = await FavoriteClient.insertAt(id, position)

    if (response.type === 'success') {
      dispatch(favoritesSet(response.data.favorites))
    }

    return response
  },
}
